import Vue from 'vue'
import App from './App.vue'

import router from "./router";
import commentFun from './util/stringUtil'
for(let fn in commentFun){
  Vue.prototype[fn] = commentFun[fn]
}
// import axios from "axios";
Vue.use(router);
Vue.config.productionTip = false;

window.vm = new Vue({
    el: "#app",
    router,
    render: h => h(App),
    beforeCreate() {
      Vue.prototype.$bus = this; //事件总线
    }
  });